// extracted by mini-css-extract-plugin
export default {"collapsibleContainer":"CompanyRowsContainer_collapsibleContainer__7353R"};